'use client'

import { usePathname } from 'next/navigation'

import { useProductBrand } from '@/providers/product-brand-provider'
import { productInternalPath } from '@/lib/product-hosts'
import { Header } from './header'

// Routes whose first section is a full-bleed dark hero — the nav overlays it
// transparently (like the homepage) instead of sitting on a solid bar.
//
// `/connect` is an exact-match case in spirit: the Soku Connect landing is the
// only page under that prefix with a hero, and the merchant OAuth landings
// beside it (`/connect/shopify` and friends) render no marketing header at all,
// so the prefix cannot reach them.
const TRANSPARENT_HEADER_PREFIXES = ['/whitepaper', '/connect', '/creativehubs']

// Tool and model catalogues (including their detail pages) use a continuous
// dark studio surface. Keep the sticky navigation in that same visual plane.
const DARK_HEADER_PREFIXES = ['/tools', '/models']
const DARK_HEADER_ROUTES = ['/ad-library']

export function MarketingHeader() {
  const brand = useProductBrand()
  const pathname = productInternalPath(new URL(brand.origin).host, usePathname() ?? '')
  const transparent = TRANSPARENT_HEADER_PREFIXES.some(p =>
    pathname.startsWith(p),
  )
  const dark =
    DARK_HEADER_ROUTES.includes(pathname) ||
    DARK_HEADER_PREFIXES.some(
      prefix => pathname === prefix || pathname.startsWith(`${prefix}/`),
    )
  return <Header transparent={transparent} dark={dark} />
}
